import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";

import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
  category: {
    color: theme?.palette?.secondary?.main,
    fontWeight: "bold",
    opacity: "1 !important",
  },
  selectFlex: {
    "& .MuiSelect-select": {
      display: "flex",
    },
  },
}));

export default function GenericPicker(props) {
  const {
    name,
    label,
    value,
    handleChange,
    list,
    touched,
    error,
    inclAny,
    anyLabel,
    open,
    setOpen,
    disabled,
    required,
    formControlSX,
    endAdornment,
    clearable,
    clearLabel,
    onClick,
  } = props;
  const classes = useStyles();

  var selectOptions = {};
  if (open !== undefined && open !== null) {
    selectOptions.open = open;
    selectOptions.native = false;
  }
  if (setOpen !== undefined && setOpen !== null) {
    selectOptions.onOpen = () => setOpen(true);
    selectOptions.onClose = () => setOpen(false);
  }

  var selectSX = {};
  if (endAdornment) {
    selectSX["& .MuiSelect-icon"] = {
      position: "relative",
      marginLeft: "-32px",
      left: "10px",
    };
  }

  return (
    <>
      <FormControl
        fullWidth
        variant="outlined"
        className={classes.formControl}
        required={required}
        sx={{ ...formControlSX }}
        onClick={onClick}
      >
        <InputLabel id={`${name}-label`}>{label}</InputLabel>
        <Select
          label={label}
          color="primary"
          variant="outlined"
          disabled={disabled}
          error={Boolean(touched && error)}
          fullWidth
          helperText={touched && error}
          labelId={`${name}-label`}
          name={name}
          value={value}
          onChange={(e) => {
            handleChange(e);
            if (setOpen) {
              setOpen(false);
            }
          }}
          endAdornment={endAdornment}
          {...selectOptions}
          sx={selectSX}
        >
          {Boolean(inclAny || inclAny === undefined) && (
            <MenuItem value="">
              <em>{anyLabel || "Any"}</em>
            </MenuItem>
          )}
          {clearable && (
            <MenuItem value="">
              <em>{clearLabel || "Clear"}</em>
            </MenuItem>
          )}
          {list &&
            list
              .filter((item) => item)
              .map((item, index) => {
                if (typeof item == "object") {
                  if (item.label !== undefined || item.value !== undefined) {
                    return (
                      <MenuItem
                        key={index}
                        value={
                          item.value !== undefined ? item.value : item.label
                        }
                      >
                        {item.label || item.value}
                      </MenuItem>
                    );
                  } else {
                    return item;
                  }
                } else {
                  return (
                    <MenuItem key={index} value={item}>
                      {item}
                    </MenuItem>
                  );
                }
              })}
        </Select>
        {Boolean(touched && error) && (
          <FormHelperText error>{error}</FormHelperText>
        )}
      </FormControl>
    </>
  );
}
